import ReactMarkdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";
import { CHAT_TYPESET_CLASS } from "@/core/components/chat-markdown/constants";

// The app's prose treatment, with one rule of its own: a guide sends people to their
// email or ServiceTitan provider for the full instructions, and they have to come back
// to finish the step, so those open in a new tab rather than navigating onboarding away.
const components: Components = {
  a: ({ node: _node, ...props }) => (
    <a {...props} target="_blank" rel="noopener noreferrer" />
  ),
  // A guide's blockquotes are callouts, not quotations, so the prose quote marks are
  // wrong here. They stay on for the chat surfaces, where a quote really is a quote.
  blockquote: ({ node: _node, ...props }) => (
    <blockquote
      {...props}
      className="[&>p]:before:content-none [&>p]:after:content-none"
    />
  ),
  // Figures of somebody else's interface. They carry a hairline and a white ground so a
  // screenshot of a white form does not bleed into the panel, and they size to the panel
  // rather than to their own pixels, which are twice what is shown for sharpness.
  img: ({ node: _node, ...props }) => (
    <img
      {...props}
      loading="lazy"
      className="my-3 w-full rounded-md border border-line bg-white"
    />
  ),
};

export const GuideMarkdown = ({ children }: { children: string }) => (
  <div className={CHAT_TYPESET_CLASS}>
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
      {children}
    </ReactMarkdown>
  </div>
);
